import { useEffect } from "react";
import { Helmet as HelmetAsync } from "react-helmet-async";
import { WofLoader } from "~/components";

export function Splash() {
  useEffect(() => {
    const favicon = document.getElementById("favicon") as HTMLLinkElement;

    if (favicon) {
      favicon.href = "data:image/x-icon;";
    }
  }, []);

  return (
    <div>
      <HelmetAsync title="Carregando" />

      <WofLoader />
    </div>
  );
}
